import { Component, Inject, OnChanges, OnDestroy } from '@angular/core';

import {OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { EventBusService } from '../../../services/event-bus.service';
import { GlobalCfgService } from 'src/services/globalcfg.service';
import { LabelScanService } from 'src/services/label-scan.service';
import { BatchService } from 'src/services/batch.services';
import { MessageService } from 'src/services/message.service';
import { MiscService } from 'src/services/misc.service';
import { Event } from 'src/services/socket-events';
import { PrintService } from 'src/services/print.service';
import { AlertComponent } from 'src/components/alert/alert.component';
import { ConfirmationDialogComponent } from 'src/components/confirm-dialog/confirm-dialog.component';
import clonedeep from "lodash.clonedeep";
import { Utils } from 'src/services/utils';

@Component({
  selector: 'rm-parent-child-label-dialog',
  templateUrl: './parent-child-label.component.html',
  styleUrls: ['./parent-child-label.component.css']
})
export class ParentChildLabelDialogComponent implements OnInit, OnDestroy {
  
  user: any;
  subscriptions: any[] = [];
  gcp: string;
  columns: any[] = [
    {name: "code", displayName: "Scanned Data"},
    {name: 'packageLevel', displayName: 'Child Type'},
    {name: "name", displayName: "Name"},
    {name: "mfgName", displayName: "Manufacturer"},
    {name: 'actions', displayName: '', type: 'actions'}
  ];

  status = "isNotPaired";
  // status = "readyToPair";
  // status = "isPaired";
  // status = "notAggregated";
  // status = "isAggregated";

  socket: any;
  connected: boolean = false;
  sentDoneEvent: boolean = false;

  labelImg: string = '';
  labelImg2: string = '';
  qrScanImg: string = '';
  hri: any;
  printCount: number = 1;
  labels: any[] = [];
  formats: any[];
  selectedFormat: string;

  locations: any[];
  locationsAll: any[];
  plant: any;
  selectedLocation: any;
  placeSelected: any;
  targetCountries: any;
  countryTargeted: any;

  deviceData: any;
  scannedData: any[] = [];
  itemsAggregated: any;
  sId: number = 0;
  packageLevel: string;
  packageType: string;
  batchNo: any;
  packageChildren: any[] = [];
  tableData: any[] = [];


  constructor(
    private dialogRef: MatDialogRef<ParentChildLabelDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ebService: EventBusService,
    private globalCfgService: GlobalCfgService,
    private labelScanService: LabelScanService,
    private batchService: BatchService,
    private msgService: MessageService,
    private miscService: MiscService,
    private printService: PrintService,
    private dialog: MatDialog,
    private utils: Utils,
  ) {
  }

  ngOnInit() {
    this.user = this.globalCfgService.getFullUserObj();

    this.packageLevel = this.data["packageLevel"];
    this.packageType = this.data["packageType"];

    if (!this.gcp) {
      this.gcp = this.globalCfgService.getGcp();
    }
    this.subscriptions.push(this.ebService.locationsListValue$.subscribe(
      (list)=> this.locations = list
    ));
    this.subscriptions.push(this.ebService.allLocationsValue$.subscribe(
      (list)=> this.locationsAll = list
    ));

    this.ebService.loadLocationsList(this.gcp);
    this.ebService.loadAllLocations(this.gcp);
    this.loadTargetCountries();
    this.loadFormats();
  }

  socketInit() {
    this.socket = this.labelScanService.startReceiver();
    this.connected = true;

    this.subscriptions.push(
      this.labelScanService.onEvent(Event.CONNECT).subscribe(() => {
        console.log("connected with socket");
      })
    );

    this.subscriptions.push(
      this.labelScanService.onEvent(Event.DISCONNECT).subscribe(() => {
        console.log("disconnected with socket");
      })
    );

    this.subscriptions.push(
      this.labelScanService.onEvent(Event.STARTPAIRING).subscribe((data: any) => {
        console.log("Got startpairing Request form Mobile App");
        console.log("startpairing event: ", data);
        this.qrScanImg = data.code;
      })
    );

    // capturing paired event and changing status to "paired"
    this.subscriptions.push(
      this.labelScanService.onEvent(Event.PAIRED).subscribe((data: any) => {
        console.log("paired event: ", data);
        this.deviceData = data;
        this.status = "isPaired";
      })
    );

    // capturing scanned event and changing status to "notAggregated"
    this.subscriptions.push(
      this.labelScanService.onEvent(Event.SCANNED).subscribe((data: any) => {
        console.log("scanned event: ", data);
        data.sId = ++this.sId
        this.scannedData.push(data);
        this.status = "notAggregated";
        setTimeout(() => {
          this.loadTable();
        }, 200);
      })
    );

    // when we get done event from mobile activate done button in UI
    this.subscriptions.push(
      this.labelScanService.onEvent(Event.DONE).subscribe((data: any) => {
        console.log("Got Done Request form Mobile App");
        if(this.sentDoneEvent==false) {
          this.generateLabel();
        }
        console.log("done event: ", data);
      })
    );

    // when we get cancel event from mobile
    this.subscriptions.push(
      this.labelScanService.onEvent(Event.CANCEL).subscribe((data: any) => {
        console.log("Got Cancel Request form Mobile App");
        this.scannedData = [];
        this.socket.disconnect();
        this.dialogRef.close();
      })
    );
  }

  setLocation(loc) {
    this.placeSelected = loc.address;
  }

  loadTargetCountries() {
    this.miscService.gteTargetCountries().subscribe(
      (response: any) => {
        this.targetCountries = response['data'];
      }
    );
  }

  onActionClicked(e) {
    console.log("onActionClicked:", e);

    var rec = e.record;
    switch (e.actionName.name) {
      case "cancel":
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
          width: '450px',
          data: {
            message: 'Are you sure you want to discard this item from packaging process?'
          }
        });

        dialogRef.afterClosed().subscribe(
          (result) => {
            if (result == 'yes') {
              this.utils.removeByAttr(this.scannedData, "sId", rec.sId);
              this.loadTable();
            }
          });
        break;
      default:
        console.log("Unhandled actionable: ", e.actionName);
    }
  }

  generateScanCode() {
    this.plant = this.locationsAll.filter(el => el["address"]==this.placeSelected);
    this.labelScanService["manufacturingPlant"] = this.plant[0];
    this.socketInit();
    this.status = "readyToPair";
  }

  cancel() {
    if(this.connected) {
      this.socket.emit('cancel');
      this.socket.disconnect();
    }
    this.dialogRef.close();
  }

  loadTable() {
    this.itemsAggregated = this.scannedData.length;
    this.tableData = clonedeep(this.scannedData);
    this.tableData.forEach(element => {
      element.actions = [
        {name: "cancel", tip: "Remove Item"}
      ];
    });
    console.log("table data:", this.tableData);
  }

  generateLabel(done?) {
    console.log('generate label: ');
  
    if(done==true) {
      this.sentDoneEvent = true;
      console.log('Sending done event...');
      this.socket.emit('done');
    }

    this.packageChildren = [];
    this.scannedData.forEach(element => {
      if (!this.packageChildren.includes(element.instanceId)) {
        this.packageChildren.push(element.instanceId);
      }
    });
    this.batchNo = this.scannedData[0]["batchNo"];

    var rec = {
      countryCode: this.countryTargeted,
      packageLevel: this.packageLevel,
      children: this.packageChildren,
      gs1ApplicationIdentifiers: ["gtin", "batchNo", "serialNo", "mfgDate", "expiryDate"],
      dappUserId: this.user["dappUserId"],
      flags: {
        geofencing: false,
        isTempSensitive: false,
        isMoistureSensitive: false,
        isLocationTrackingOn: false,
        isLightExposureMonitoringOn: false,
        isShockMonitoringOn: false
      }
    };

    if(this.packageLevel=="tertiary" && this.packageType=="homogeneous"){
      rec["packageType"] = this.packageType;
      rec["batchNo"] = this.batchNo;
    } else if(this.packageLevel=="tertiary" && this.packageType=="heterogeneous") {
      rec["packageType"] = this.packageType;
    } else {
      rec["batchNo"] = this.batchNo;
    }

    console.log("record sent for request", rec);
    this.batchService.createPackage(rec).subscribe(
      (response: any)=> {
        if (response.status) {
          this.status = "isAggregated";
          console.log("create package response: ", response)
          this.labelImg = 'data:image/png;base64,' + response.label[0].code;
          this.hri = response.label[0].hri;
          if(response.label.length > 1) {
            this.labelImg2 = 'data:image/png;base64,' + response.label[1].code;
          }
        } else {
          this.msgService.showError(this.msgService.labelsCreateFail);
        }
      }
    );
  }

  loadFormats() {
    this.printService.getPrintFormats().subscribe(
      (result: any)=> {
        this.formats = result['data'];
      });
  }

  print(format) {
    if (!format) {
      const dialogRef = this.dialog.open(AlertComponent, {
        width: "450px",
        data: { 
          note: "Please select a print format before printing",
        },
      });

      return;
    }
    if (this.labels.length > 0) {
      this.labels = [];
    }
    var obj = {};

    if(this.packageLevel=="tertiary" && this.packageType=="homogeneous"){
      obj["imgs"] = [];
      obj["imgs"].push({img: this.labelImg});
      obj["imgs"].push({img: this.labelImg2});
    // } else if(this.packageLevel=="tertiary" && this.packageType=="heterogeneous") {
    } else {
      obj["img"] = this.labelImg;
      obj["hri"] = this.hri;
    }

    for (var i = 0; i < this.printCount; i++) {
      this.labels.push(obj);
    }
    var printWin = window.open('', 'new div', 'height=400,width=600');
    var htmlStr = this.printService.getHtmlStr(format, this.labels);

    console.log(htmlStr);

    printWin.document.write(htmlStr);
    printWin.print();
    // printWin.close();

    this.socket.disconnect();
    // this.dialogRef.close();
  }

  ngOnDestroy() {
    if(this.connected) {
      this.socket.disconnect();
    }
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}